/**
 * タグコンボボックス用モデル
 */
export class Tag {

    /** タグID. */
    TagId = '';

    /** タグ名. */
    TagName = '';

    /** タグID名. */
    TagIdName = '';
}
